import { type ReactNode } from 'react';

import styles from './Badge.module.css';

export const MAX_BADGES = 2; // We should show only 2 badges for Pairings / Products
export const MAX_BADGES_FOR_YOU = 1;

export type BadgeVariant =
  | 'New'
  | 'NewAlt'
  | 'Misc'
  | 'OnTheWay'
  | 'InYourCart'
  | 'Skipped'
  | 'Delivered'
  | 'Incomplete'
  | 'ComingUp'
  | 'ShadeOverlay'
  | 'PromoComplete'
  | 'PromoIncomplete'
  | 'Sale';

interface Props {
  testid?: string;
  children: ReactNode;
  className?: string;
  variant?: BadgeVariant;
}

const getClassNamesForVariant = (variant?: BadgeVariant) => {
  switch (variant) {
    case 'New':
      return styles['new'];
    case 'NewAlt':
      return styles['new-alt'];
    case 'Misc':
      return styles['misc'];
    case 'OnTheWay':
      return styles['on-the-way'];
    case 'InYourCart':
      return styles['in-your-cart'];
    case 'Skipped':
      return styles['skipped'];
    case 'Delivered':
      return styles['delivered'];
    case 'Incomplete':
      return styles['incomplete'];
    case 'ComingUp':
      return styles['coming-up'];
    case 'ShadeOverlay':
      return styles['shade-overlay'];
    case 'PromoComplete':
      return styles['promo-complete'];
    case 'PromoIncomplete':
      return styles['promo-incomplete'];
    case 'Sale':
      return styles['sale'];
  }
  return '';
};

export function Badge(props: Props) {
  const { testid, children, variant, className } = props;

  return (
    <div
      data-testid={testid}
      className={`${styles.container} ${getClassNamesForVariant(
        variant
      )} ${className}`}
    >
      {children}
    </div>
  );
}
